import * as types from './mutation-types'
import {http} from '../lib/http'
import router from '../router/index'

var queue = [];

export default {
    init({ dispatch }) {
        dispatch('auth/init')
    },
    stopLoading({commit}) {
        commit('WAIT_LOADING', false);
        commit('SET_LOADING', false);
    },
    startLoading({commit, dispatch}) {
        commit('WAIT_LOADING', true);
        setTimeout(() => dispatch('checkLoading'), 200)
    },
    
    checkLoading({state, commit}) {
        if (state.waitLoading) {
            commit('SET_LOADING', true)
        }
    },
    
    toggleSearch({state, commit}, flag) {
        commit('SET_SHOWSEARCH', flag)
    },

    doSearch({commit, state}) {
        commit('SET_SEARCH_RESULTS', {})
        return http.get('/api/ideas/search/'+state.search).then((data) => {
            // if (data && data.account && data.account.id) {
            //     router.push({ name: 'account', params: {id: data.account.id}})
            //     commit('SET_SHOWSEARCH', false)
            //     data = []
            // }
            commit('SET_SEARCH_RESULTS', data)
        })
    },

    showInfo ({commit, dispatch}, timeout = 400) {
        commit('SET_SHOWINFO', true);
        setTimeout(() => dispatch('hideInfo'), timeout)
    },

    hideInfo({commit}){
        commit('SET_SHOWINFO', false);
    }

}


// WEBPACK FOOTER //
// ./src/store/actions.js